// extracted by mini-css-extract-plugin
export default {"container":"OO-z","timeTop":"PO-z","timeCountdown":"QO-z","cta":"RO-z","disabled":"SO-z","product":"TO-z"};